import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular/main';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
import { SharedModule } from '../shared/shared.module';
import { ReportsService } from './reports.service';

@NgModule({
  imports: [
    CommonModule,
    ReportsRoutingModule,
    AgGridModule.withComponents([]),
    SharedModule
  ],
  declarations: [ReportsComponent],
  providers: [ReportsService]
})

export class ReportsModule { }


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/reports/reports.module.ts